import { IMdlCustomDialogConfiguration, MdlDialogService } from '@angular-mdl/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { REASONS_STORAGE_TOKEN } from '../../../audit-trail/audit-trail-reason.component';
import { ActionsMenuAgRendererComponent, ActionsMenuItem } from '../../../covance-ag-grid';
import { ActionsMenuColumn } from '../../../shared/grid-columns';
import { EQueryAdminSummary } from '../models/e-query-admin-summary';
import { EQueryHideReasonStorage } from './e-query-hide-reason-storage';
import { EQueryUnhideReasonStorage } from './e-query-unhide-reason-storage';
import { EQueryHideDialogComponent, HIDE_TOKEN } from './hide-dialog/e-query-hide-dialog.component';

@Component({
    selector: 'e-query-hide-menu-ag-renderer',
    template: require('../../../covance-ag-grid/renderers/actions-menu-ag-renderer-base.html'),
    styles: [require('../../../covance-ag-grid/renderers/actions-menu-ag-renderer-base.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HideMenuAgRendererComponent extends ActionsMenuAgRendererComponent<EQueryAdminSummary> {

    constructor(private dialogService: MdlDialogService) {
        super();
    }

    public createMenuItems(data: EQueryAdminSummary, colDef: ActionsMenuColumn<EQueryAdminSummary>): ActionsMenuItem[] {
        const menuItems: ActionsMenuItem[] = [];        
        const isAdministrator = colDef.userPermissions && colDef.userPermissions.has('EQueryAdministration');
        if (isAdministrator && !data.isHidden) {
            menuItems.push({
                title: 'Hide',
                onClick: () => {
                    this.hideEQuery(data);
                }
            });
        }
        return menuItems;
    }

    private hideEQuery(report: EQueryAdminSummary) {
        const configDialog: IMdlCustomDialogConfiguration = {
            component: EQueryHideDialogComponent,
            providers: [{
                provide: HIDE_TOKEN, useValue: report
            },
            {
                provide: REASONS_STORAGE_TOKEN,
                useExisting: report.isHidden ? EQueryUnhideReasonStorage : EQueryHideReasonStorage
            }],
            isModal: true,
            clickOutsideToClose: true
        };

        this.dialogService.showCustomDialog(configDialog);
    }
}
